import { EFiltersActionType, IChangeJsonQuery } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const justChangeJsonQuery = actionGenerator<EFiltersActionType.ChangeJsonQuery, IChangeJsonQuery>(
  EFiltersActionType.ChangeJsonQuery,
);
